module.exports = __webpack_public_path__ + "static/media/theme-status-success.4a9f81cf.png";